import { useRef } from 'react'
import ColoredBar from './coloredBar'
import Container from './container'
import Marca from './marca'

export default function Banner({
  image = '',
  imageMobile = '',
  title = '',
  subtitle = '',
  marca = null,
  hoveredBrand = null,
  brands = [],
}) {
  // Ref para o banner
  const bannerRef = useRef(null)

  return (
    <div className="flex flex-col w-full relative">
      <div
        ref={bannerRef}
        className={`bg-[url('../assets/${imageMobile}')] aspect-square h-[calc(100vw+200px)] lg:h-screen lg:bg-[url('../assets/${image}')] bg-no-repeat bg-cover bg-bottom flex flex-col items-center justify-center p-2 relative md:static transition-all duration-500`}
      >
        {(title || subtitle) && (
          <Container className="text-white z-10 w-full text-center lg:text-left pt-12 lg:pt-28 flex flex-col justify-center h-full">
            {title && (
              <h1 className="text-5xl md:text-[86px] font-titillium-web-bold mb-2 tracking-wider">
                {title}
              </h1>
            )}
            {subtitle && (
              <p className="text-xs md:text-2xl font-titillium-web tracking-wider">
                {subtitle}
              </p>
            )}
          </Container>
        )}

        {/* Componente Marca */}
        {marca && (
          <div className="absolute bottom-0 w-full z-10">
            <Marca
              color={marca.color}
              logoSrc={marca.logoSrc}
              brand={hoveredBrand}
            />
          </div>
        )}
      </div>
      <img
        src="../assets/black-shadow.png"
        alt=""
        className="block absolute bottom-0 w-full left-0 h-[80vh] lg:top-auto top-[20%] z-0"
      />
      {/* Colored bar at the bottom of the banner */}
      <ColoredBar
        className="mt-0 z-30"
        hoveredBrand={hoveredBrand}
        brands={brands}
      />
    </div>
  )
}
